<template>
<div class="chapter">
<div class="inner_page">
<div class="cover" epub:type="cover" id="_idContainer000">
<p class="center"><img alt="cover image" class="i300" src="image/9780738760797.jpg"/>
</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Cover.vue?39ea1fe8